import styled from "styled-components";

export const LayoutPagePromptManagementWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px;
    height: 100%;
    flex-grow: 1;
`;

export const LayoutPagePromptManagementHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    height: 48px;

    flex-shrink: 0;
    align-self: stretch;
`;

export const LayoutPagePromptManagementTitle = styled.h1`
    ${props => props.theme.fonts.variant.regular()};
    margin: 0;
    padding: 0;
    font-size: 1em;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.15px;
    flex: 1;
`;

export const LayoutPagePromptManagementContent = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    flex: 1;
`;
